import { SnackbarContext } from "App";
import axios from "axios";
import { PinnedLogsContext } from "components/AllLogHistoryNew";
import useUserContext from "hooks/context-hooks/useUserContext";
import { useContext } from "react";
import { useMutation } from "react-query";

export const useUpdateNote = (callBack?: () => void) => {
  const { user } = useUserContext();
  const contextData = useContext(PinnedLogsContext);
  const { setSnack } = useContext(SnackbarContext);
  const { mutate, isLoading } = useMutation(
    async (updateData: any) => {
      console.log(updateData);
      const response = await axios.put(
        `https://test.dentistfind.com/api/v1/notes/${updateData.id}`,
        { ...updateData, api_token: user?.token }
      );
      return response.data;
    },
    {
      onSuccess: () => {
        contextData?.refetchPinnedLogs && contextData.refetchPinnedLogs();
        contextData?.refetchNotes && contextData.refetchNotes();
        contextData?.refetchLogHistory && contextData.refetchLogHistory();
        setSnack({
          open: true,
          severity: "success",
          message: "Note updated",
        });
        callBack && callBack();
      },
    }
  );

  return [mutate, isLoading] as const;
};
